// required to shape the data to accommodate the usage for the sliders
export function computeBaseFactorForUI(level: number) {
  return -Math.abs(level)
}

export function normalizeTrafficFactor(level: number) {
  return Math.abs(level)
}
